import React, { useState } from 'react';
import Skeleton from '@material-ui/lab/Skeleton';

const BACKEND_URL = (process.env.REACT_APP_BACKEND_URL || 'https://api.virtus-one.com').replace(/\/$/, '');
const ASSESSMENT_PICTURE_PATH = '/staticFiles/images/assessment_pictures/';

function getAssessmentPictureUrl(pathname) {
  const filename = pathname.slice(pathname.indexOf(ASSESSMENT_PICTURE_PATH) + ASSESSMENT_PICTURE_PATH.length);
  return `${BACKEND_URL}/static-files/assessment-picture/${filename.split('/').map(encodeURIComponent).join('/')}`;
}

export function resolveExerciseImageUrl(imageUrl) {
  const value = String(imageUrl || '').trim();
  if (!value) return '';

  if (!/^https?:\/\//i.test(value)) {
    if (value.startsWith(ASSESSMENT_PICTURE_PATH)) return getAssessmentPictureUrl(value);
    return value.startsWith('/') ? `${BACKEND_URL}${value}` : `${BACKEND_URL}/static-files/assessment-picture/${encodeURIComponent(value)}`;
  }

  try {
    const parsed = new URL(value);
    if (parsed.pathname.startsWith(ASSESSMENT_PICTURE_PATH)) return getAssessmentPictureUrl(parsed.pathname);
    if ((parsed.hostname === 'localhost' || parsed.hostname === '127.0.0.1')
      && (parsed.pathname.startsWith('/static-files/') || parsed.pathname.startsWith('/media/') || parsed.pathname.startsWith('/static/'))) {
      return `${BACKEND_URL}${parsed.pathname}${parsed.search}${parsed.hash}`;
    }
  } catch (error) {
    return value;
  }

  return value;
}

export default function ExerciseImage({ exercise = {}, alt, className, style, height, skeletonWidth, skeletonHeight }) {
  const [failedToLoad, setFailedToLoad] = useState(false);
  const imageUrl = resolveExerciseImageUrl(exercise.img || exercise.picture || exercise.pictureURL || exercise.image_url);

  if (!imageUrl || failedToLoad) {
    return <Skeleton variant="rect" width={skeletonWidth} height={skeletonHeight} />;
  }

  return <img alt={alt || exercise.title || 'Exercise'} className={className} style={style} height={height} src={imageUrl} onError={() => setFailedToLoad(true)} />;
}